export default {
  COLLAGE_GALLERY: '50486504-48ff-4d1c-b3b1-5a34641580e3',
  FREESTYLE_GALLERY: '26d747d1-eb05-49e6-b59b-6caef4e4db5f',
  CLOSE_BUTTON: '5abbc1a8-075f-42ff-9dbb-3f8ed7032f30',
};
